// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vec-option__Option-module--ej0PF.ant-radio-button-wrapper {
    --vec-option-pad-x: var(--space-md);
    --vec-option-pad-left: var(--vec-option-pad-x);
    display: flex !important;
    align-items: center;
    width: 100%;
    height: auto !important;
    margin: 0 !important;
    padding: var(--space-sm) var(--vec-option-pad-x) var(--space-sm) var(--vec-option-pad-left) !important;
    border: none !important;
    border-radius: var(--radius-md) !important;
    background: var(--color-surface-raised) !important;
    color: var(--color-text-primary) !important;
    text-align: left;
}

.vec-option__Option-module--ej0PF.ant-radio-button-wrapper::before {
    display: none !important;
}

.vec-option__Option-module--ej0PF.ant-radio-button-wrapper-checked {
    background: var(--color-primary-100) !important;
    color: var(--color-text-primary) !important;
}

.vec-option__Option-module--ej0PF:has(:focus-visible) {
    outline: 2px solid var(--color-focus-outline) !important;
    outline-offset: 2px;
}

.vec-option__Option-module--ej0PF .ant-radio-button-label {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    flex: 1;
    min-width: 0;
}

.vec-option-lead__Option-module--PYPuP {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

[data-scrolls] .vec-option__Option-module--ej0PF .ant-radio-button-label {
    gap: 0;
    background: inherit;
}

[data-scrolls] .vec-option-lead__Option-module--PYPuP {
    position: sticky;
    left: 0;
    z-index: 1;
    align-self: stretch;
    margin-left: calc(-1 * var(--vec-option-pad-left));
    padding-inline: var(--vec-option-pad-left) var(--space-sm);
    background: inherit;
}

.vec-option-badge__Option-module--E5NE5 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--color-surface-base);
    color: var(--color-text-primary);
    font-weight: 600;
}

.vec-option__Option-module--ej0PF.ant-radio-button-wrapper-checked .vec-option-badge__Option-module--E5NE5 {
    background: var(--color-surface-brand);
    color: var(--color-text-on-brand);
}

.vec-option__Option-module--ej0PF.vec-option-correct__Option-module--vDOhQ {
    background: var(--color-feedback-success-bg) !important;
}

.vec-option__Option-module--ej0PF.vec-option-correct__Option-module--vDOhQ .vec-option-badge__Option-module--E5NE5 {
    background: var(--color-feedback-success-text) !important;
    color: var(--color-text-on-brand) !important;
}

.vec-option__Option-module--ej0PF.vec-option-incorrect__Option-module--EQbfZ {
    background: var(--color-feedback-error-bg) !important;
}

.vec-option__Option-module--ej0PF.vec-option-incorrect__Option-module--EQbfZ .vec-option-badge__Option-module--E5NE5 {
    background: var(--color-feedback-error-text) !important;
    color: var(--color-text-on-brand) !important;
}

.vec-option-content__Option-module--ZKtI1 {
    flex: 1;
    min-width: 0;
    font-size: calc(var(--vec-option-font-size, 18px) * var(--eq-scale, 1));
}

/* below tablet: BREAKPOINTS.tablet (768) */
@media (max-width: 767px) {
    .vec-option__Option-module--ej0PF.ant-radio-button-wrapper {
        --vec-option-pad-left: var(--space-sm);
    }

    .vec-option-badge__Option-module--E5NE5 {
        width: 24px;
        height: 24px;
        font-size: 14px;
    }

    .vec-option-content__Option-module--ZKtI1 {
        --vec-option-font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./vector/src/Option/Option.module.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,8CAA8C;IAC9C,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,sGAAsG;IACtG,uBAAuB;IACvB,0CAA0C;IAC1C,kDAAkD;IAClD,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,+CAA+C;IAC/C,2CAA2C;AAC/C;;AAEA;IACI,wDAAwD;IACxD,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,mBAAmB;IACnB,kDAAkD;IAClD,0DAA0D;IAC1D,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,yDAAyD;IACzD,4CAA4C;AAChD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,uDAAuD;IACvD,4CAA4C;AAChD;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,uEAAuE;AAC3E;;AAEA,2CAA2C;AAC3C;IACI;QACI,sCAAsC;IAC1C;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".vec-option:global(.ant-radio-button-wrapper) {\n    --vec-option-pad-x: var(--space-md);\n    --vec-option-pad-left: var(--vec-option-pad-x);\n    display: flex !important;\n    align-items: center;\n    width: 100%;\n    height: auto !important;\n    margin: 0 !important;\n    padding: var(--space-sm) var(--vec-option-pad-x) var(--space-sm) var(--vec-option-pad-left) !important;\n    border: none !important;\n    border-radius: var(--radius-md) !important;\n    background: var(--color-surface-raised) !important;\n    color: var(--color-text-primary) !important;\n    text-align: left;\n}\n\n.vec-option:global(.ant-radio-button-wrapper)::before {\n    display: none !important;\n}\n\n.vec-option:global(.ant-radio-button-wrapper-checked) {\n    background: var(--color-primary-100) !important;\n    color: var(--color-text-primary) !important;\n}\n\n.vec-option:has(:focus-visible) {\n    outline: 2px solid var(--color-focus-outline) !important;\n    outline-offset: 2px;\n}\n\n.vec-option :global(.ant-radio-button-label) {\n    display: flex;\n    align-items: center;\n    gap: var(--space-sm);\n    flex: 1;\n    min-width: 0;\n}\n\n.vec-option-lead {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n[data-scrolls] .vec-option :global(.ant-radio-button-label) {\n    gap: 0;\n    background: inherit;\n}\n\n[data-scrolls] .vec-option-lead {\n    position: sticky;\n    left: 0;\n    z-index: 1;\n    align-self: stretch;\n    margin-left: calc(-1 * var(--vec-option-pad-left));\n    padding-inline: var(--vec-option-pad-left) var(--space-sm);\n    background: inherit;\n}\n\n.vec-option-badge {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: var(--color-surface-base);\n    color: var(--color-text-primary);\n    font-weight: 600;\n}\n\n.vec-option:global(.ant-radio-button-wrapper-checked) .vec-option-badge {\n    background: var(--color-surface-brand);\n    color: var(--color-text-on-brand);\n}\n\n.vec-option.vec-option-correct {\n    background: var(--color-feedback-success-bg) !important;\n}\n\n.vec-option.vec-option-correct .vec-option-badge {\n    background: var(--color-feedback-success-text) !important;\n    color: var(--color-text-on-brand) !important;\n}\n\n.vec-option.vec-option-incorrect {\n    background: var(--color-feedback-error-bg) !important;\n}\n\n.vec-option.vec-option-incorrect .vec-option-badge {\n    background: var(--color-feedback-error-text) !important;\n    color: var(--color-text-on-brand) !important;\n}\n\n.vec-option-content {\n    flex: 1;\n    min-width: 0;\n    font-size: calc(var(--vec-option-font-size, 18px) * var(--eq-scale, 1));\n}\n\n/* below tablet: BREAKPOINTS.tablet (768) */\n@media (max-width: 767px) {\n    .vec-option:global(.ant-radio-button-wrapper) {\n        --vec-option-pad-left: var(--space-sm);\n    }\n\n    .vec-option-badge {\n        width: 24px;\n        height: 24px;\n        font-size: 14px;\n    }\n\n    .vec-option-content {\n        --vec-option-font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vecOption": `vec-option__Option-module--ej0PF`,
	"vecOptionLead": `vec-option-lead__Option-module--PYPuP`,
	"vecOptionBadge": `vec-option-badge__Option-module--E5NE5`,
	"vecOptionCorrect": `vec-option-correct__Option-module--vDOhQ`,
	"vecOptionIncorrect": `vec-option-incorrect__Option-module--EQbfZ`,
	"vecOptionContent": `vec-option-content__Option-module--ZKtI1`
};
export default ___CSS_LOADER_EXPORT___;
